import { SECTION_CATALOG } from '../sections/section-catalog.js';

export const ACTIVITY_RETENTION_DAYS = 90;
export const ACTIVITY_THROTTLE_MS = 5 * 60_000;
export const ACTIVITY_SECTIONS = [
  ...SECTION_CATALOG.map(({ id, label }) => ({ id: id as string, label })),
  { id: 'admin', label: 'Админка' },
  { id: 'cabinet', label: 'Кабинет без workspace' },
];
export function activityDay(now = new Date()): string {
  return now.toISOString().slice(0, 10);
}
export function activityStartDay(days: number, now = new Date()): string {
  return activityDay(new Date(now.getTime() - (days - 1) * 86_400_000));
}
